import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.object.to-string.js";
import { ScalingSquaresSpinner } from "epic-spinners";
import StatusBar from "./components/StatusBar";
import ActionModal from "./components/ActionModal";
import { applyUpdate } from "./registerServiceWorker";
export default {
  name: "App",
  components: {
    StatusBar: StatusBar,
    ScalingSquaresSpinner: ScalingSquaresSpinner,
    ActionModal: ActionModal
  },
  data: function data() {
    return {
      note: ""
    };
  },
  computed: {
    isBlockingNote: function isBlockingNote() {
      // コメント内の文字列には反応しないよう、タグの属性として付いているかを見る
      return /<\w[^>]*\sdata-blocking[\s=>]/.test(this.note);
    }
  },
  mounted: function mounted() {
    this.fetchNote();
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  },
  methods: {
    fetchNote: function fetchNote() {
      var _this = this;
      fetch("/note.html", {
        cache: "no-cache"
      }).then(function (res) {
        res.text().then(function (html) {
          _this.note = html;
        });
      });
    },
    handleVisibilityChange: function handleVisibilityChange() {
      // モーダル表示中のみ、アプリに戻ったときに再取得して停止解除を反映する
      if (document.visibilityState === "visible" && this.isBlockingNote) {
        this.fetchNote();
      }
    },
    dismissUpdate: function dismissUpdate() {
      this.$store.dispatch("setNewVersionAvailable", false);
    },
    handleApplyUpdate: function handleApplyUpdate() {
      this.$store.dispatch("setNewVersionAvailable", false);
      applyUpdate();
    }
  }
};